import styled from 'styled-components';
import { gray, white } from '~/components/mixins/color';

export const Container = styled.div`
  width: 100%;
`;

export const Content = styled.div`
  height: 60px;
  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  flex: 1;

  .title {
    width: 100%;
    display: inline;
    color: ${white.hex()};
    font-weight: 400;
    font-size: 19px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size-adjust: 0.58;
  }

  @media (max-width: 1024px) {
    .title {
      min-width: 70%;
      display: inline;
      color: ${white.hex()};
      font-weight: 400;
      font-size: 19px;
      text-overflow: ellipsis;
      font-size-adjust: 0.58;
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 260px;
  width: 260px;
  max-width: 260px;
  padding-left: 10px;
  margin-left: 10px;
  border-left: 1px solid rgba(255, 255, 255, 0.10);

  @media (max-width: 1024px) {
    display: none;
  }

  .profile-info {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
    flex: 1;

    strong {
      display: block;
      color: ${white.hex()};
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
    }

    span {
      display: block;
      margin-top: 1px;
      font-size: 12px;
      color: ${gray.hex()};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-transform: lowercase;
      max-width: 200px;

      &::first-line {
        text-transform: capitalize;
      }
    }
  }
  .profile-avatar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
    width: 50px;
    flex: 0 0 50px;
  }

  img {
    height: 35px;
    width: 35px;
    object-fit: cover;
    border-radius: 10px;
    transition: background 0.5s;

    &:hover {
      opacity: 0.6;
    }
  }
`;
